import { image } from "../assets/manifest";

const EMPTY_STATE_IMAGES: Array<{ words: string[]; image: string }> = [
  { words: ["记录", "历史"], image: image.historyNotebook },
  { words: ["小组", "排行", "对比"], image: image.trophy },
  { words: ["备份", "服务器", "管理数据"], image: image.data },
  { words: ["课堂", "座位", "点名"], image: image.classroomSeat },
  { words: ["预设"], image: image.manual },
  { words: ["审计", "账号", "教师", "权限", "机构"], image: image.teacher },
  { words: ["分享", "链接"], image: image.modalSad },
  { words: ["归档"], image: image.teacher },
  { words: ["洞察", "评比"], image: image.insights }
];

function emptyStateImage(title: string) {
  const text = String(title || "");
  return EMPTY_STATE_IMAGES.find((item) => item.words.some((word) => text.includes(word)))?.image || image.emptyStudents;
}

type EmptyStateProps = {
  title: string;
  detail?: string;
  imageSrc?: string;
};

export function EmptyState({ title, detail, imageSrc }: EmptyStateProps) {
  const src = imageSrc || emptyStateImage(title);
  return (
    <div className="empty-state">
      <img className="empty-state-img" src={src} alt="" />
      <strong>{title}</strong>
      {detail ? <span>{detail}</span> : null}
    </div>
  );
}
